/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：571
 */

module.exports = function (e) {
  return e && e.__esModule ? e : {
    default: e
  }
}
